import BigNumber from 'bignumber.js'
import React, { useState, useRef, useEffect } from 'react'
import { CardBody, Flex, Text, CardRibbon, useTooltip, useMatchBreakpoints } from '@pixel-nft/uikit'
import UnlockButton from 'components/UnlockButton'
import { getBalanceNumber } from 'utils/formatBalance'
import { useTranslation } from 'contexts/Localization'
import { convertLockPeriod } from 'utils/dateHandle'
import { BIG_ZERO } from 'utils/bigNumber'
import { LendingPool } from 'state/types'
import { useCheckLockedOfPool } from 'hooks/useCheckLocked'
import { usePIXELpool, useERC20 } from 'hooks/useContract'
import EventBus from 'utils/eventBus'
import { StyledCard, StyledCardInner } from './StyledCard'
import CardFooter from './CardFooter'
import CardActions from './CardActions'
import StyledCardHeaderNew from './StyledCardHeaderNew'

const LendingPoolCard: React.FC<{ pool: LendingPool; account: string; userData: any; userPoolData: any }> = ({
  pool,
  account,
  userData,
  userPoolData,
}) => {
  const { t } = useTranslation()
  const isRunning = userPoolData?.poolIsRunning ? userPoolData.poolIsRunning : false
  const { isSm } = useMatchBreakpoints()
  const isMobile = isSm
  const needPxf = getBalanceNumber(new BigNumber(pool.minimumPXF), 18).toLocaleString()

  return (
    <StyledCard style={{ maxWidth: isMobile ? '100%' : '31.5%' }}>
      <StyledCardInner>
        <StyledCardHeaderNew isStaking={isRunning} earningTokenSymbol="USDT" stakingTokenSymbol="USDT" />

        <CardBody style={{ padding: '0 24px 24px 24px' }}>
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontSize="14px">APR</Text>
            <Text bold>{pool.annualInterestRate}%</Text>
          </Flex>
          <Flex alignItems="center" justifyContent="space-between" mt="6px">
            <Text fontSize="14px">Earn:</Text>
            <Text bold> USDT </Text>
          </Flex>
          <Flex alignItems="center" justifyContent="space-between" mt="6px">
            <Text fontSize="14px">Lockup:</Text>
            <Text bold> {convertLockPeriod(pool.lockPeriod)} </Text>
          </Flex>
          <Flex alignItems="center" justifyContent="space-between" mt="6px">
            <Text fontSize="14px">PXF:</Text>
            <Text bold> {needPxf} </Text>
          </Flex>
          <Flex flexDirection="column">
            {account ? <CardActions pool={pool} userData={userData} userPoolData={userPoolData} /> : <UnlockButton />}
          </Flex>
        </CardBody>
        <CardFooter />
      </StyledCardInner>
    </StyledCard>
  )
}

export default LendingPoolCard
